<template>
  <div>
    <div class="d-flex justify-space-between align-center my-4">
      <h3>إدارة القوائم المنسدلة</h3>
      <v-btn color="primary" @click="openAddDialog">
        <v-icon left>mdi-plus</v-icon>
        إضافة قائمة منسدلة جديدة
      </v-btn>
    </div>

    <v-card v-if="!loading">
      <v-data-table
        :headers="headers"
        :items="dropdowns"
        :loading="loading"
        :server-items-length="total"
        :items-per-page="perPage"
        @update:page="handlePageChange"
        class="elevation-1"
      >
        <template v-slot:[`item.is_active`]="{ item }">
          <v-chip :color="item.is_active ? 'success' : 'error'" small>
            {{ item.is_active ? 'نشط' : 'غير نشط' }}
          </v-chip>
        </template>

        <template v-slot:[`item.items_count`]="{ item }">
          {{ item.items_count || 0 }}
        </template>

        <template v-slot:[`item.actions`]="{ item }">
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn color="primary" small icon v-bind="attrs" v-on="on">
                <v-icon>mdi-dots-vertical</v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item @click="openEditDialog(item)">
                <v-list-item-icon>
                  <v-icon>mdi-pencil</v-icon>
                </v-list-item-icon>
                <v-list-item-title>تعديل</v-list-item-title>
              </v-list-item>
              <v-list-item @click="viewItems(item)">
                <v-list-item-icon>
                  <v-icon>mdi-eye</v-icon>
                </v-list-item-icon>
                <v-list-item-title>عرض العناصر</v-list-item-title>
              </v-list-item>
              <v-list-item @click="deleteDropdown(item.id)" v-if="!item.deleted_at">
                <v-list-item-icon>
                  <v-icon>mdi-delete</v-icon>
                </v-list-item-icon>
                <v-list-item-title>حذف</v-list-item-title>
              </v-list-item>
              <v-list-item @click="restoreDropdown(item.id)" v-if="item.deleted_at">
                <v-list-item-icon>
                  <v-icon>mdi-restore</v-icon>
                </v-list-item-icon>
                <v-list-item-title>استعادة</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </template>
      </v-data-table>
    </v-card>

    <!-- Add/Edit Dialog -->
    <v-dialog v-model="dialog" max-width="600px" persistent>
      <v-card>
        <v-card-title>
          <span class="headline">{{ editMode ? 'تعديل' : 'إضافة' }} قائمة منسدلة</span>
        </v-card-title>
        <v-card-text>
          <v-form ref="form" v-model="valid">
            <v-text-field
              v-model="form.key"
              label="المفتاح (Key)"
              :rules="[rules.required]"
              :disabled="editMode"
              required
            ></v-text-field>
            <v-text-field
              v-model="form.title"
              label="العنوان"
            ></v-text-field>
            <v-textarea
              v-model="form.description"
              label="الوصف"
            ></v-textarea>
            <v-switch
              v-model="form.is_active"
              label="نشط"
            ></v-switch>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="closeDialog">إلغاء</v-btn>
          <v-btn color="primary" @click="saveDropdown" :loading="saving">حفظ</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Items Dialog -->
    <DropdownItemsDialog
      v-model="itemsDialog"
      :dropdown-id="selectedDropdownId"
    />

    <!-- Delete Confirmation Dialog -->
    <v-dialog v-model="deleteDialog" max-width="400px" persistent>
      <v-card>
        <v-card-title class="headline">تأكيد الحذف</v-card-title>
        <v-card-text>
          هل أنت متأكد من حذف هذه القائمة المنسدلة؟
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="deleteDialog = false">إلغاء</v-btn>
          <v-btn color="error" @click="confirmDelete" :loading="loading">حذف</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Axios from "axios";
import DropdownItemsDialog from "./DropdownItemsDialog.vue";

export default {
  name: "DropdownSettingsIndex",
  components: {
    DropdownItemsDialog,
  },
  data() {
    return {
      loading: false,
      saving: false,
      dropdowns: [],
      total: 0,
      perPage: 10,
      currentPage: 1,
      dialog: false,
      itemsDialog: false,
      editMode: false,
      selectedDropdownId: null,
      valid: false,
      form: {
        id: null,
        key: "",
        title: "",
        description: "",
        is_active: true,
      },
      headers: [
        { text: "المفتاح", value: "key" },
        { text: "العنوان", value: "title" },
        { text: "عدد العناصر", value: "items_count" },
        { text: "الحالة", value: "is_active" },
        { text: "العمليات", value: "actions", sortable: false },
      ],
      deleteDialog: false,
      itemToDelete: null,
      rules: {
        required: (v) => !!v || "هذا الحقل مطلوب",
      },
    };
  },
  methods: {
    async fetchDropdowns() {
      this.loading = true;
      try {
        const response = await Axios.post(
          `${this.$store.state.url}/employee/admin/dropdowns`,
          {
            page: this.currentPage,
            per_page: this.perPage,
          },
          {
            headers: this.request_headers(),
          }
        );
        this.dropdowns = response.data.payload.data;
        this.total = response.data.payload.count;
      } catch (error) {
        this.showPopup("error", error.response?.data?.message || "حدث خطأ");
      } finally {
        this.loading = false;
      }
    },
    openAddDialog() {
      this.editMode = false;
      this.form = {
        id: null,
        key: "",
        title: "",
        description: "",
        is_active: true,
      };
      this.dialog = true;
    },
    openEditDialog(item) {
      this.editMode = true;
      this.form = {
        id: item.id,
        key: item.key,
        title: item.title,
        description: item.description,
        is_active: item.is_active,
      };
      this.dialog = true;
    },
    closeDialog() {
      this.dialog = false;
      this.$refs.form?.reset();
    },
    async saveDropdown() {
      if (!this.$refs.form.validate()) return;

      this.saving = true;
      try {
        if (this.editMode) {
          await Axios.post(
            `${this.$store.state.url}/employee/admin/update-dropdown/${this.form.id}`,
            this.form,
            {
              headers: this.request_headers(),
            }
          );
        } else {
          await Axios.post(
            `${this.$store.state.url}/employee/admin/add-dropdown`,
            this.form,
            {
              headers: this.request_headers(),
            }
          );
        }

        this.showPopup("success", `تم ${this.editMode ? "تعديل" : "إضافة"} القائمة المنسدلة بنجاح`);
        this.closeDialog();
        this.fetchDropdowns();
      } catch (error) {
        this.showPopup("error", error.response?.data?.message || "حدث خطأ");
      } finally {
        this.saving = false;
      }
    },
    deleteDropdown(id) {
      this.itemToDelete = id;
      this.deleteDialog = true;
    },
    async confirmDelete() {
      if (!this.itemToDelete) return;

      try {
        await Axios.get(`${this.$store.state.url}/employee/admin/delete-dropdown/${this.itemToDelete}`, {
          headers: this.request_headers(),
        });
        this.showPopup("success", "تم الحذف بنجاح");
        this.deleteDialog = false;
        this.itemToDelete = null;
        this.fetchDropdowns();
      } catch (error) {
        this.showPopup("error", error.response?.data?.message || "حدث خطأ");
        this.deleteDialog = false;
        this.itemToDelete = null;
      }
    },
    async restoreDropdown(id) {
      try {
        await Axios.post(
          `${this.$store.state.url}/employee/admin/restore-dropdown/${id}`,
          {},
          {
            headers: this.request_headers(),
          }
        );
        this.showPopup("success", "تم الاستعادة بنجاح");
        this.fetchDropdowns();
      } catch (error) {
        this.showPopup("error", error.response?.data?.message || "حدث خطأ");
      }
    },
    viewItems(item) {
      this.selectedDropdownId = item.id;
      this.$nextTick(() => {
        this.itemsDialog = true;
      });
    },
    handlePageChange(page) {
      this.currentPage = page;
      this.fetchDropdowns();
    },
  },
  created() {
    this.fetchDropdowns();
  },
};
</script>
